// extracted by mini-css-extract-plugin
export default {"skeleton":"styles_skeleton__mr+HH","item":"styles_item__hZDec"};